<template>
  <div id='login_box'>
    <div id='header'>
      <img id='logo_img' src='../../assets/login/logo.png'>
    </div>
    <div id='body'>
      <ul class='chg-login'>
        <li @click='chgLoginType(1)' :class='{"active": nowIndex===1}' class='tab-title'>账号密码登录</li>
        <li @click='chgLoginType(2)' :class='{"active": nowIndex===2}' class='tab-title'>手机快速登录</li>
      </ul>
      <div v-show='nowIndex===1' id='account_login_div'>
        <div id='account_div'>
          <img src='../../assets/login/user_login_name_icon.png'>
          <input v-model='user_mobile' class='text-input' id='mobile_input' placeholder="请输入手机号">
        </div>
        <div id='passwd_div'>
          <img src='../../assets/login/user_pwd_icon.png'>
          <input v-model='user_passwd' class='text-input' type='password' placeholder="请输入密码">
        </div>
      </div>

      <div v-show='nowIndex===2' id='fast_login_div'>
        <div id='fast_account_div'>
          <img src='../../assets/login/user_login_name_icon.png'>
          <input v-model='fast_mobile' class='text-input' id='fast_mobile' placeholder="请输入手机号">
        </div>
        <div id='fast_code_div'>
          <input v-model='validate_code' class='text-input' id='input_pass_code' placeholder="请输入验证码">
          <button @click='getPassCode' id='get_pass_code'>{{authCodeBtnText}}</button>
        </div>
      </div>

<!--      <div id='login_setting'>-->
<!--        <div id='checkbox-passwd'>-->
<!--          <input type='checkbox' id='keep_passwd'>-->
<!--          <label for='keep_passwd' class='login-setting-label-text'>记住密码</label>-->
<!--        </div>-->
<!--        <div id='checkbox-autologin'>-->
<!--          <input type='checkbox' id='auto_login'>-->
<!--          <label for='auto_login' class='login-setting-label-text'>自动登录</label>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div id='footer'>
      <button @click='Login' id='loginBtn'>登录</button>
      <div id='account_passwd_div'>
        <span id='register_account' @click="$router.push('/register')">注册账号</span>
        <span id='forget_passwd' @click="$router.push('/forget-password')">忘记密码</span>
      </div>
    </div>

  </div>
</template>

<script>
import cache from '@/common/cache.js'
export default {
  name: 'Login',
  data () {
    return {
      nowIndex: 1,
      user_mobile: '',
      user_passwd: '',
      validate_code: '',
      fast_mobile: '',
      authCodeBtnText: '获取验证码',
      countDownClock: null
    }
  },
  created () {
    this.$api.login.autoLogin().then((res) => {
      if (res.code === 0) {
        let userType = res.type
        if (userType === 'admin') {
          console.log('跳入管理员系统')
          this.$router.replace('/')
        } else if (userType === 'teacher') {
          console.log('跳入老师系统')
          this.$router.replace('/teaIndex')
        } else if (userType === 'student') {
          console.log('跳入学生系统')
          this.$router.replace('/stuIndex')
        } else if (userType === 'assistant') {
          console.log('进入助教系统')
          this.$router.replace('/assistantIndex')
        }
      }
    })
  },
  methods: {
    chgLoginType (index) {
      this.nowIndex = index
    },
    getPassCode () {
      if (this.countDownClock) {
        return
      }
      if (!this.fast_mobile) {
        return this.$message.warning('请输入手机号')
      }
      var param = {'area_code': '86', 'mobile': this.fast_mobile}
      this.$api.login.getLoginAuthCode(param).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.countDown(60)
        this.$message.success('获取成功')
      }).catch(err => {
        this.$message.error(err)
      })
    },
    countDown (wait) {
      if (!wait) {
        clearTimeout(this.countDownClock)
        this.countDownClock = null
        this.authCodeBtnText = '获取验证码'
      } else {
        this.authCodeBtnText = '获取验证码(' + wait + 's)'
        wait--
        this.countDownClock = setTimeout(() => {
          this.countDown(wait)
        }, 1000)
      }
    },
    Login () {
      if (this.nowIndex === 1) {
        // 手机号+密码登录
        if (!this.user_mobile) {
          return this.$message.error('请输入手机号')
        } else {
          // TODO: 验证手机号是否合法
        }
        if (!this.user_passwd) {
          return this.$message.error('请输入密码')
        }

        // let userinfo = {area_code: '86', mobile: this.user_mobile, passwd: this.user_passwd}
        let userinfo = {mobile: this.user_mobile, passwd: this.user_passwd}
        this.$api.login.login(userinfo).then((res) => {
          console.log(res)
          if (res.code === 0) {
            // this.$store.state.identityInfo = res.data
            cache.savePhone(this.user_mobile)
            this.$router.replace('/identity')
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      if (this.nowIndex === 2) {
        // 手机号快速登录
        if (!this.fast_mobile) {
          return this.$message.error('请输入手机号')
        } else {
          // todo.验证手机号
        }
        if (!this.validate_code) {
          return this.$message.error('请输入验证码')
        }
        var data = {area_code: '86', mobile: this.fast_mobile, auth_code: this.validate_code}
        this.$api.login.loginByAuthCode(data).then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success('登录成功')
          this.$router.replace('/')
        }).catch(err => {
          this.$message.error(err)
        })
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
#login_box {
  width: 387px;
  height: 526px;
  position:absolute;
  top:50%;
  left:50%;
  margin:-263px 0 0 -193px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 30px #aca9a9;
}
.tab-title {
  font-family: 'PingFangSC-Regular';
  font-size: 15px;
  color: #999999;
  letter-spacing: 0;
}
.text-input::-webkit-input-placeholder {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.text-input::-moz-placeholder {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.text-input::-ms-input-placeholder {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.text-input {
  margin: 5%;
  width: 80%;
  font-size: 14px;
  height: 20px;
  border: none;
  outline: none;
  font-family: 'PingFangSC-Regular';
}
#header {
  margin-top: 5%;
  text-align: center;
}
#body {
  margin: 10% 15%;
  text-align: center;
}
.chg-login {
  cursor: pointer;
}
.chg-login li {
  font-family: 'PingFangSC';
  list-style-type: none;
  display: inline-block;
  padding: 3%;
  border-bottom: 2px solid #999999;
}
li.active {
  border-bottom: 2px solid #8ECDCE;
  color: #8ECDCE;
}
#account_login_div {
  margin-top: 3%;
}
#account_div {
  display: inline-block;
  width: 85%;
  border-bottom: 1px solid #DADADA;
}
#passwd_div {
  display: inline-block;
  width: 85%;
  border-bottom: 1px solid #DADADA;
}
#fast_login_div {
  margin-top: 3%;
}
#fast_account_div {
  display: inline-block;
  width: 85%;
  border-bottom: 1px solid #DADADA;
}
#fast_code_div {
  display: inline-block;
  width: 85%;
  border-bottom: 1px solid #DADADA;
}
#input_pass_code {
  margin-left: 0px;
  width: 45%;
}
#get_pass_code {
  width: 100px;
  height: 24px;
  background-color: #f1f1f1;
  border: none;
  border-radius: 10px;
  color: #999999;
  font-size: 12px;
  font-family: 'PingFangSC-Regular';
  letter-spacing: 0;
  outline: none;
  cursor: pointer;
}
#login_setting {
  margin: 15px;
}
#checkbox-passwd {
  float: left;
  margin-left: 3%;
}
#checkbox-autologin {
  overflow: hidden;
  margin-left: 55%;
}
#keep_passwd {
  display: none;
}
#keep_passwd:checked+label::before {
  vertical-align: middle;
  padding-right: 5px;
  content: url('../../assets/login/checkbox_select.png');
}
#keep_passwd:not(:checked)+label::before {
  vertical-align: middle;
  padding-right: 5px;
  content: url('../../assets/login/checkbox_bg.png')
}
#auto_login {
  display: none;
}
#auto_login:checked+label::before {
  vertical-align: middle;
  padding-right: 5px;
  content: url('../../assets/login/checkbox_select.png')
}
#auto_login:not(:checked)+label::before {
  vertical-align: middle;
  padding-right: 5px;
  content: url('../../assets/login/checkbox_bg.png')
}
.login-setting-label-text {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
}
#footer {
  margin-top: 10%;
  text-align: center;
}
#loginBtn {
  outline: none;
  width: 250px;
  height: 35px;
  background-color: #5dc0ba;
  border: none;
  border-radius: 20px;
  /* 按钮字体设置 */
  font-family: 'PingFangSC-Medium';
  font-size: 15px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
#account_passwd_div {
  margin-top: 10%;
}
#register_account {
  float: left;
  margin-left: 20%;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #5DC0BA;
  letter-spacing: 0;
}
#forget_passwd {
  margin-left: 15%;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #C1C1C1;
  letter-spacing: 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/page/login/Login.vue